import { gql } from '@apollo/client';

const queryEditableFields = (environmentUri: string) => {
    return {
        variables: {
            environmentUri,
        },
        query: gql`
            query GetEnvironment($environmentUri: String) {
                getEnvironment(environmentUri: $environmentUri) {
                    description
                    tags
                    label
                    originSamlGroupName
                    originSamlFullDevGroupName
                    originSamlReaderGroupName
                    identityProviderName
                    blockpreview
                    quicksight_enabled
                }
            }
        `,
    };
};

export default queryEditableFields;
